<template>
   <div id="keys">
      <van-row >
          <img class="background" src="@/assets/333.png"/>
      </van-row>
      <van-row style="margin-top: -10px;">
        <van-search
          v-model="value"
          show-action
          label="酒店名称"
          placeholder="请输入搜索关键词"
          @search="onSearch"
        >
         <template #action>
          <div @click="onClickButton">搜索</div>
          </template>
        </van-search>
      </van-row>
      <van-row class="keysListRow" :style="{height: scrollerHeight}">
            <van-list
            v-model:loading="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            >
              <van-cell v-for="item in list" :key="item" >
                <van-col span="14">
                  <van-col span="24" style="font-size: 16px;">{{item.hotelName}}(过期)</van-col>
                  <van-col span="24">开始时间:{{item.beginTime}}</van-col>
                  <van-col span="24">结束时间:{{item.endTime}}</van-col>
                </van-col>
                <van-col span="5"><div style="margin-top:15px;text-align: center;">{{item.roomName}}</div></van-col>
                <van-col span="5">
                  <van-button type="info" style="float: right;margin-top: 10px;">开锁</van-button>
                </van-col>
               
              </van-cell>
          </van-list>
      </van-row>
      <van-tabbar v-model="active" @change="onChange">
        <van-tabbar-item name="keys" icon="home-o">钥匙</van-tabbar-item>
        <van-tabbar-item name="me" icon="friends-o">我的</van-tabbar-item>
      </van-tabbar>
   </div>  
</template>

<script>
export default {
   data() {
     return {
        value: '',
        active:'keys',
        list:[],
        loading:false,
        finished:false,
     }
   },
   computed: {
        // 滚动区高度 
        scrollerHeight: function() {
          return (window.innerHeight - 280) + 'px'; //自定义高度需求
        }
    },
   created() {
    
   },
   methods: {
      onClickButton(){
          alert(this.value);
        },
        onSearch(){
          alert(this.value);
        },
        onChange(){
          switch(this.active){
            case 'keys':
              this.$router.push({ path: "ekeyList" });
              break
            case 'me':
              this.$router.push({ path: "me" });
              break  
          }
        },
        onLoad () {  
         
          this.loading = false;
        },
   }
}
</script>

<style>
html,
body {
  overflow-x: hidden;
  /* overflow-y: hidden; */
}
.background {
 width: 100%;
 height: 180px;
 background-size: cover;
}
.userinfo {
display: flex;
flex-direction: column;
align-items: center;
position:fixed;
left:40%;
top:6.5%;
}
.userinfo-avatar {
width: 128rpx;
height: 128rpx;
margin-left: -15rpx;
border-radius: 50%;
}
.userinfo-nickname {
font-style:italic;
font-size: 16px;
margin-left: -35rpx;
font-weight:bold;
color: white;
}
.keysListRow{
  overflow-y:auto;
}
</style>


// WEBPACK FOOTER //
// src/components/app/ekeyList.vue